import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  CreateItemApiModel,
  QuizListApiModel,
  QuizApiModel,
  QuizzesRequestApiModel,
  QuizSelectorsApiModel,
  ProgramSettingsUsageInfoApiModel,
  QuizzesSelectorsApiModel
} from '@app/api/api-models';
import { toQueryParams } from 'src/app/shared/utils';
import { CrudService } from '@app/api/api-services/crud.service.base';

@Injectable()
export class ProgramQuizzesService extends CrudService<QuizApiModel, QuizListApiModel, number> {
  public apiUrl = 'program-quizzes';

  public getList(request?: QuizzesRequestApiModel): Observable<QuizListApiModel[]> {
    return this.http.get<QuizListApiModel[]>(`${this.apiUrl}`, { params: toQueryParams(request) });
  }

  public getById(id: number): Observable<QuizApiModel> {
    return this.http
      .get<QuizApiModel>(`${this.apiUrl}/${id}`)
      .pipe(map((data) => new QuizApiModel().deserialize(data)));
  }

  public getSelectors(): Observable<QuizzesSelectorsApiModel> {
    return this.http.get<QuizzesSelectorsApiModel>(`${this.apiUrl}/selectors`);
  }

  public getSelectorsById(id: number): Observable<QuizSelectorsApiModel> {
    return this.http.get<QuizSelectorsApiModel>(`${this.apiUrl}/${id}/selectors`);
  }

  public create(model: CreateItemApiModel): Observable<QuizApiModel> {
    return this.http.post<QuizApiModel>(`${this.apiUrl}/create`, model);
  }

  public update(model: QuizApiModel): Observable<QuizApiModel> {
    return super.update(model).pipe(map((data) => new QuizApiModel().deserialize(data)));
  }

  public getPrint(id: number): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/${id}/print`, { responseType: 'blob' });
  }

  public getUsageInfo(id: number): Observable<ProgramSettingsUsageInfoApiModel> {
    return this.http.get<ProgramSettingsUsageInfoApiModel>(`${this.apiUrl}/${id}/usage-info`);
  }

  public getUnused(): Observable<QuizListApiModel[]> {
    return this.http.get<QuizListApiModel[]>(`${this.apiUrl}/unused`);
  }

  public addBatch(ids: number[]): Observable<number[]> {
    return this.http.post<number[]>(`${this.apiUrl}/add-batch`, ids);
  }
}
